import { Cashdesk, createUnblockCashdeskMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type UnblockCashdeskModel = ConfirmModalModel<Cashdesk, number, null>;

export const createUnblockCashdeskModel = (): UnblockCashdeskModel => {
	const unblockCashdeskMutation = createUnblockCashdeskMutation();

	const model = createConfirmModalModel<Cashdesk, number, null>({
		modalData: declareModalData<Cashdesk>(),
		mapModalData: ({ id }) => id,
		mutation: unblockCashdeskMutation,
		successMessageKey: 'unblock-cashdesk.success',
	});

	return model;
};
